import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { Flex } from "../../Container/Flex";
import { Secondary } from "../../../utils/style/texts";
import { PinInput } from "react-input-pin-code";
import { Content } from "../../Alert/style";
import React from "react";

const PincodeEntryAction = ({
  activePincode,
  onEnter,
  pincodeVal,
  setPincodeVal,
}) => {
  const [t] = useTranslation();

  return (
    <Flex col fullWidth>
      <Flex col align="flex-start" style={{ marginBottom: 20 }}>
        <Secondary>{t("pincodeEntryAction.explanation")}</Secondary>
      </Flex>
      <br />
      <Content
        fullWidth
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <PinInput
          mask
          autoSelect={true}
          autoFocus={true}
          showState={false}
          inputStyle={{ width: 60, height: 60, fontSize: 26 }}
          values={pincodeVal}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onEnter();
            }
          }}
          onChange={(value, index, values) => {
            setPincodeVal(values);
          }}
        />
      </Content>
    </Flex>
  );
};

export function mapDispatchToProps() {
  return {};
}

const mapStateToProps = createStructuredSelector({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withTranslation(), withConnect)(PincodeEntryAction);
